import React from 'react';

const Tos = (props) => {
  return (
    <div>
      <h1>Terms of Service</h1>
    </div>
  )
}

export default Tos;